import { render, staticRenderFns } from "./AnzeigeBig.vue?vue&type=template&id=94f949ca&scoped=true&"
import script from "./AnzeigeBig.vue?vue&type=script&lang=js&"
export * from "./AnzeigeBig.vue?vue&type=script&lang=js&"
import style0 from "./AnzeigeBig.vue?vue&type=style&index=0&id=94f949ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f949ca",
  null
  
)

export default component.exports